// Formateo de montos y fechas, con la configuración de Costa Rica.

export const formatCurrency = (amount) =>
  new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
  }).format(amount);

/**
 * Convierte a fecha lo que viene de la base: "2026-09-08 07:16:14".
 *
 * Dos cuidados:
 *
 * 1. Se cambia el espacio por una "T". Safari no acepta el formato con
 *    espacio y devuelve "Invalid Date", así que en un iPhone no se vería
 *    ninguna fecha.
 *
 * 2. Ese texto no trae zona horaria: ya ES la hora de Costa Rica, la que
 *    escribió el servidor. Por eso se lee como hora local y se muestra
 *    tal cual, sin convertir. Convertirla a una zona fija corría la hora
 *    en cualquier computadora que no estuviera puesta en Costa Rica.
 */
const parsearFecha = (valor) => new Date(String(valor).replace(" ", "T"));

export const formatDateTime = (valor) =>
  new Intl.DateTimeFormat("es-CR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(parsearFecha(valor));

// Solo la hora y el minuto. En la lista del día los segundos son ruido.
export const formatHora = (valor) =>
  new Intl.DateTimeFormat("es-CR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(parsearFecha(valor));

// Fecha de hoy en formato YYYY-MM-DD, según el reloj de la máquina.
// No se usa toISOString() porque convierte a UTC y en Costa Rica eso
// adelanta el día a partir de las 6 de la tarde.
export const getTodayLocal = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Los dos días, puestos a medianoche. Así se comparan días de calendario
// y no horas transcurridas.
const aMedianoche = (fecha) =>
  new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime();

/**
 * Cuánto hace de una fecha, en palabras: "Hoy", "Ayer", "Hace 3 días",
 * "Hace 2 meses". Sirve para ver de un vistazo quién lleva rato sin
 * aparecer por el negocio.
 *
 * Cuenta días de calendario, no bloques de 24 horas: una venta de ayer a
 * las 10 de la mañana es "Ayer" desde el primer minuto de hoy, aunque no
 * hayan pasado 24 horas todavía.
 */
export const tiempoRelativo = (valor) => {
  if (!valor) return "Sin movimientos";

  const dias = Math.round(
    (aMedianoche(new Date()) - aMedianoche(parsearFecha(valor))) / 86400000
  );

  if (dias <= 0) return "Hoy";
  if (dias === 1) return "Ayer";
  if (dias < 30) return `Hace ${dias} días`;

  const meses = Math.floor(dias / 30);
  if (meses < 12) return `Hace ${meses} ${meses === 1 ? "mes" : "meses"}`;

  const anios = Math.floor(dias / 365);
  return `Hace ${anios} ${anios === 1 ? "año" : "años"}`;
};
